import { composeIO } from 'react-compose-io'
import { tabelaIO } from './Tabela.IO'
import TabelaView from './Tabela.View'

export const Tabela = composeIO(TabelaView, tabelaIO)
